import React, { PropsWithChildren } from 'react';

import Avatar from '@/core/components/Avatar';
import Icons from '@/core/components/Icons';
import { ProfileTitle } from '@/core/components/ProfileDetails/components';
import type UserDomain from '@/core/lib/new-architecture/domain/user.domain';
import { AbstractRoute } from '@/core/lib/router/route';
import { useRouterContext } from '@/core/lib/router/router.context';
import Routes from '@/core/lib/router/routes';

export const UserIntroductionSection: React.FC<
  Pick<ReturnType<UserDomain['getPublicInfo']>, 'avatarUrl' | 'username'> & { uuid: UserDomain['uuid']; isSmall?: boolean; isSuperUser: UserDomain['status']['isSuperUser'] }
> = ({ username, avatarUrl, isSmall, uuid, isSuperUser }) => {
  const Tag = isSmall ? ButtonContainer : DivContainer;
  return (
    <Tag href={new Routes.PublicProfileRoute(uuid)}>
      <Avatar avatarUrl={avatarUrl} size={isSmall ? '52' : '100'} isSuperUser={isSuperUser} />
      <div className="flex-grow">
        <ProfileTitle tag={isSmall ? 'p' : 'h1'} isSmall={isSmall}>
          {username}
        </ProfileTitle>
        {/* add here userTags like "#étudiant", "#famille" */}
      </div>
      {isSmall && <Icons icon="chevron-right" />}
    </Tag>
  );
};
const className = 'flex w-full items-center gap-2 text-left';
const ButtonContainer: React.FC<PropsWithChildren<{ href: AbstractRoute }>> = ({ children, href }) => {
  const { Link } = useRouterContext();
  return (
    <Link href={href} className={className}>
      {children}
    </Link>
  );
};
const DivContainer: React.FC<PropsWithChildren<{ href?: AbstractRoute }>> = ({ children }) => {
  return <div className={className}>{children}</div>;
};
